import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './lib/domNodePatch'
import './i18n'
import './index.css'
import App from './App'

// Lazy-load Sentry + analytics after first render to reduce initial bundle
if (import.meta.env.PROD) {
  // Sentry: dynamic import — removes ~57KB from initial bundle
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN
  if (sentryDsn) {
    import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: sentryDsn,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0.1,
        enabled: true,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [Sentry.replayIntegration()],
      })
    })
  }

  // Analytics + cookie consent: dynamic import — removes ~153KB PostHog from initial bundle
  import('./lib/analytics').then(({ initAnalyticsWithConsent }) => {
    initAnalyticsWithConsent()
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
